var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiamond = function SvgDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.176 21.684-11-13.123L4.476 2h15.4l3.3 6.561zM9.096 7.741h6.16l-2.062-4.1h-2.035zm2.255 10.417V9.381H4.01zm1.65 0 7.343-8.776H13zM17.1 7.74h3.74l-2.063-4.1h-3.74zm-13.585 0h3.74l2.062-4.1h-3.74z"
  })));
};
export default SvgDiamond;